import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Movements from "./pages/Movements";
import { initInstallPrompt } from "./lib/pwa";

function App() {
  useEffect(() => {
    initInstallPrompt();
  }, []);

  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/prodotti" element={<Products />} />
            <Route path="/movimenti" element={<Movements />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AppProvider>
    </div>
  );
}

export default App;
